import "./index.css";
import "./api/axiosConfig"; // Must be before any API imports to register interceptors
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { AuthProvider } from "./stores/Auth/auth.provider";
import { UserProvider } from "./stores/User/User.provider";
import { BrowserRouter } from "react-router-dom";
import { WebSocketProvider } from "./stores/WebSocket/WebSocket.provider";
import { createRoot } from "react-dom/client";
import { ApiProvider } from "./api/ApiProvider";
import { queryClient } from "./stores/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

const root = createRoot(container);

root.render(
  <BrowserRouter>
    <AuthProvider>
      <UserProvider>
        <ApiProvider>
          <QueryClientProvider client={queryClient}>
            <WebSocketProvider>
              <App />
            </WebSocketProvider>
          </QueryClientProvider>
        </ApiProvider>
      </UserProvider>
    </AuthProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
